import { connect } from 'react-redux';
import { OutlinedInput, IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import FilterToggle from './FilterToggle';
import FilterStack from './FilterStack';
import classes from './classes.module.scss';

import useFilter, {
  NUMBER,
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  EQUALS,
  NOT_EQUAL
} from 'app/hooks/useFilter';

// filter class (doesn't change)
const FILTER_CLASS = NUMBER;

// enabled filter types
const FILTER_TYPES = [
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  EQUALS,
  NOT_EQUAL
]

// default filter type for new filters in stack
const DEFAULT_FILTER_TYPE = FILTER_TYPES[0];

const NumberFilterStack = props => {
  return (
    <FilterStack
      {...props}
      FilterComponent={NumberFilter}
      filterClass={FILTER_CLASS}
      defaultFilterType={DEFAULT_FILTER_TYPE}
    />
  );
}

const NumberFilter = props => {
  const valueFormatter = event => event.target.value;

  const {
    value,
    filterType,
    setFilterType,
    onChange,
    clearValue
  } = useFilter({
    ...props,
    filterClass: FILTER_CLASS,
    filterType: DEFAULT_FILTER_TYPE,
    valueFormatter
  });

  const filterToggle = <FilterToggle filterType={filterType} filterTypes={FILTER_TYPES} setFilterType={setFilterType} />;

  let clearIcon = null;
  if (value) {
    clearIcon = (
      <InputAdornment position="end">
        <IconButton className={classes.filterIconButton} onClick={clearValue}>
          <CloseIcon className={classes.filterIcon} />
        </IconButton>
      </InputAdornment>
    )
  }

  let sx = {
    height: '2.5rem'
  }
  if (props.sx) {
    sx = { ...sx, ...props.sx };
  }

  const inputProps = {
    disableUnderline: true,
    sx: {
      display: 'block !important',
      height: '2.5rem',
      padding: '0 0.5rem',
      borderRadius: '2px !important'
    }
  }

  if (!props.darkMode) {
    inputProps.sx.backgroundColor = '#fff !important';
  }
  
  return (
    <OutlinedInput
      type="number"
      startAdornment={filterToggle}
      endAdornment={clearIcon}
      step="1"
      min="0"
      variant="filled"
      size="small"
      sx={sx}
      onChange={onChange}
      //InputProps={inputProps}
      defaultValue={value}
    />
  );
}

const mapStateToProps = state => ({
  darkMode: state.portalReducer.darkMode
});

export default connect(mapStateToProps)(NumberFilterStack);

